// Register components
import Vue from "vue"
import Tab from "../components/common/template/tabs/Tab"
import MenuManager from "../components/manager/tabs/Menu/Menu"
import MenuMe from "../components/me/tabs/Menu/Menu"
import Form from "../components/common/Form/Form"
import FormField from "../components/common/Form/FormField"
import ReviewsManager from "../components/manager/tabs/Reviews/Reviews"
import ReviewsMe from "../components/me/tabs/Reviews/Reviews"
import StoriesManager from "../components/manager/tabs/Stories/Stories"
import StoriesMe from "../components/me/tabs/Stories/Stories"
import Feed from "../components/me/tabs/Feed/Feed"
import Websites from "../components/manager/tabs/Websites/Websites"
import Products from "../components/manager/tabs/Products/Products"
import GroupsManager from "../components/manager/tabs/Groups/Groups"
import GroupsMe from "../components/me/tabs/Groups/Groups"
import Invitations from "../components/manager/tabs/Invitations/Invitations"
import SuggestionsParams from "../components/manager/tabs/Suggestions/SuggestionsParams"
import AccountMe from "../components/me/tabs/Account/Account"
import AccountManager from "../components/manager/tabs/Account/Account"
import Social from "../components/me/tabs/Social/Social"
import Documentation from "../components/common/tabs/Documentation/Documentation"
import DocumentationDialogue from "../components/common/tabs/Documentation/DocumentationDialogue"
import NotificationsManager from "../components/manager/tabs/Notifications/Notifications"
import NotificationsMe from "../components/manager/tabs/Notifications/Notifications"
import DocumentationDiv from "../components/common/tabs/Documentation/DocumentationDiv"
import { comeFromManager } from "@/helpers"
import Tooltip from "../components/common/template/Tooltip"
import AvatarField from "../components/common/Form/AvatarField"
import Parameters from "../components/manager/tabs/Parameters/Parameters"

Vue.component("Tab", Tab)
Vue.component("Form", Form)
Vue.component("FormField", FormField)
Vue.component("AvatarField", AvatarField)
Vue.component("Tooltip", Tooltip)

// Register all tabs
if (comeFromManager()) {
  Vue.component("Menu", MenuManager)
  Vue.component("Websites", Websites)
  Vue.component("Products", Products)
  Vue.component("Invitations", Invitations)
  Vue.component("Parameters", Parameters)
  Vue.component("SuggestionsParams", SuggestionsParams)
  Vue.component("Groups", GroupsManager)
  Vue.component("Reviews", ReviewsManager)
  Vue.component("Account", AccountManager)
  Vue.component("Stories", StoriesManager)
  Vue.component("Notifications", NotificationsManager)
} else {
  Vue.component("Menu", MenuMe)
  Vue.component("Feed", Feed)
  Vue.component("Account", AccountMe)
  Vue.component("Social", Social)
  Vue.component("Groups", GroupsMe)
  Vue.component("Reviews", ReviewsMe)
  Vue.component("Stories", StoriesMe)
  Vue.component("Notifications", NotificationsMe)
}

Vue.component("Documentation", Documentation)

// Other components
Vue.component("DocumentationDialogue", DocumentationDialogue)
Vue.component("DocumentationDiv", DocumentationDiv)
